<rid-mechanic-background />

<rid-mechanic-wrapper>
  <rid-top-bar class="block w-full" name="Wisselklanken" [steps]="this.assignments().length" [progress]="progress()" />

  <rid-mechanic-content>
    <!-- title -->
    <rid-mechanic-title [title]="'Tik op de klanken totdat het goede woord er staat'" />

    <!-- assignment -->
    @for (assignment of [assignment()]; track assignment) {
      <div class="absolute flex flex-col gap-24" animate.leave="anim-fade-out">
        <rid-option
          #item
          [option]="assignment.prompt"
          animate.enter="wait-500 anim-pop-in"
          (animationend)="$event.animationName === 'pop-in' ? onItemPoppedIn() : undefined"
        />
        <div class="flex place-content-center gap-2" animate.enter="wait-750 anim-pop-in">
          @for (klank of text(); track $index) {
            <rid-klank-switch-klank [klank]="klank" (click)="change($index)" />
          }
        </div>
      </div>
    }

    <!-- button -->
    <rid-bottom-button content="Klaar!" (clicked)="check()" [disabled]="isEvaluating()" />

    <!-- feedback overlay -->
    <rid-overlay-feedback #overlayFeedback />
  </rid-mechanic-content>
</rid-mechanic-wrapper>
